import React from 'react';

import { Helmet } from 'react-helmet';

import { getAppTitle } from '@utils/get-app-title';
import { getFaviconPath } from '@utils/get-favicon-path';

import { config } from '@/config.ts';

const ReactHelmet = () => {
	return (
		<Helmet>
			<title>{getAppTitle(config.BRAND)}</title>
			<link rel='icon' href={getFaviconPath(config.BRAND)} />
		</Helmet>
	);
};

export default ReactHelmet;
